import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {
  level: 3,
  className: null,
};

const propTypes = {
  level: PropTypes.oneOf([3, 4]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default function TertiaryTitle({ level, className, children }) {
  const Level = `h${level}`;

  return (
    <Level
      className={clsx(
        'text-xl font-semibold leading-tight tracking-tight',
        className
      )}
    >
      {children}
    </Level>
  );
}

TertiaryTitle.defaultProps = defaultProps;
TertiaryTitle.propTypes = propTypes;
